import React, { memo } from 'react'
import { useDroppable } from '@dnd-kit/core'
import OperatorItem from './OperatorItem'
import DataItem from './DataItem'
import classNames from 'classnames'
import { useContext } from "react";
import {DraggingAssignContext} from "src/components/pages/sales/business-rule/logic/FormulaComponent";

const Droppable = memo(({ id, items, vertical, embedded, highlight, varList = false, ...props }) => {
  const { draggingAssign } = useContext(DraggingAssignContext);
  const { setNodeRef } = useDroppable({ id, disabled: draggingAssign })
  return (
    <div
      ref={setNodeRef}
      className={classNames('sortable_list', { embedded: embedded })}
      style={{ display: vertical ? 'block' : 'flex' }}
    >
      {items?.map((item) => {
        if (item.isData) {
          return <DataItem item={item} key={item.id} varList={varList} {...props} />
        }
        return <OperatorItem item={item} key={item.id} highlight={highlight} {...props} />
      })}
    </div>
  )
})

export default Droppable
